import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Passes() {
  return <OperationalResource title="Pass Planner" resource="passes" />;
}
